import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {validationsList_template} from "../../../common/js/vnKnockoutJsTemplates/validationsList_template";
import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {presetFilter_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/presetFilter_template";
import {filterDate_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDate_template";
import {infoButton_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/infoButton_template";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";

declare var ko: any;

export class loginStats_template extends vnTemplate {

    public validationsList: validationsList_template;
    protected brandsFilter: multipleSelector_template;
    protected datesFilter: filterDate_template;
    public presetFilter: presetFilter_template;
    protected countriesFilter : multipleSelector_template;
    public toolTipLoginSearchBar: infoButton_template;
    public toolTipLoginNetCr: infoButton_template;
    public toolTipPremiumNetCr: infoButton_template;
    public toolTipVotes: infoButton_template;
    public toolTipRatingVotes: infoButton_template;
    public toolTipPollStartRatio: infoButton_template;
    public toolTipQuizStartRatio: infoButton_template;
    public toolTipUniqueArticles: infoButton_template;
    public toolTipTags: infoButton_template;
    public toolTipTotalInteractions: infoButton_template;
    public toolTipDynamicEvents: infoButton_template;
    public toolTipNetSubs: infoButton_template;
    public toolTipNetPageviewPercent: infoButton_template;
    public toolTipTotalLoginCr: infoButton_template;
    public toolTipTagListRatingLogin: infoButton_template;
    public toolTipNewsletterWidgetsLogin: infoButton_template;
    public permalinkFilter: filterSimple_template;
    



    readonly viewModes = [
        {'id': 'daily', 'name': 'Daily'},
        {'id': 'brands', 'name': 'Brands'},
    ];

    readonly deviceOptions = [
        { "id": "all", "name": "All"},
        { "id": "Mobile", "name": "Mobile"},
        { "id": "Desktop", "name": "Desktop"},
    ];

    protected getTemplateName(): string {

        return "loginStats_template";
    }

    protected getMainElementType(): string {

        return "div";
    }

    protected getMainElementClasses(): Array<string> {

        return ["w-content"];
    }

    protected initPartial(): void {
        this.presetFilter = new presetFilter_template("presetFilter", this.getTemplateViewModel(), this.caller);
        this.presetFilter.setType('loginStats');

        this.brandsFilter = new multipleSelector_template("brandsFilter", this.getTemplateViewModel(), this.caller);
        this.brandsFilter.setTagContainerId('selected-brands');
        this.brandsFilter.setTagContainerCaption('Selected brands:');
        this.brandsFilter.setLabel("brands");
        this.brandsFilter.setLogoEnabled(true);

        this.validationsList = new validationsList_template("validationList", this.getTemplateViewModel(), this);

        this.countriesFilter = new multipleSelector_template("countriesFilter", this.getTemplateViewModel(), this.caller);
        this.countriesFilter.setLabel("countries");
        this.countriesFilter.setFilterContainerClass('margin-neg');
        this.countriesFilter.setTagContainerId('selected-countries');
        this.countriesFilter.setTagContainerCaption('Selected countries:');

        this.permalinkFilter = new filterSimple_template("permalinkFilter", this.getTemplateViewModel(), this.caller);


        this.datesFilter = new filterDate_template("datesFilter", this.getTemplateViewModel(), this.caller);

        let date = new Date();
        date.setHours(0,0,0,0);
        let firstOfMonth = new Date(date.getFullYear(),date.getMonth(), 1);

        // if it is the first day of the month, we display data from the last month
        if(date.getTime() === firstOfMonth.getTime()){

            firstOfMonth = new Date(date.getFullYear(),date.getMonth() - 1, 1);
            date.setDate(date.getDate() - 1);
        }else{

            date.setDate(date.getDate() - 1);
        }

        this.datesFilter.setDateRange(firstOfMonth, date);


        let toolTipLoginSearchBarContent = `
            <p>This allows you to search partial matches, contained in the following fields:
                <ul>
                    <li>permalink</li>
                    <li>for fast results, use full permalink with leading and trailing slashes</li>
                </ul>
            </p>
        `;
        this.toolTipLoginSearchBar = new infoButton_template('toolTipLoginSearchBar', this.getTemplateViewModel(), this.caller)
        this.toolTipLoginSearchBar.setTitle('Search Bar');
        this.toolTipLoginSearchBar.setContent(toolTipLoginSearchBarContent);

        let toolTipLoginNetCrContent = `
            <p>Calculated as (Returning Logins + New Accounts) / (Article Limit Events - Dismissed)</p>
        `;
        this.toolTipLoginNetCr = new infoButton_template('toolTipLoginNetCr', this.getTemplateViewModel(), this.caller)
        this.toolTipLoginNetCr.setTitle('Net Conversion Rate');
        this.toolTipLoginNetCr.setContent(toolTipLoginNetCrContent);


        let toolTipPremiumNetCrContent = `
            <p>Calculated as (Returning Logins from Premium Blocker + New User from Premium Blocker) / (Premium Blocker)</p>
        `;
        this.toolTipPremiumNetCr = new infoButton_template('toolTipPremiumNetCr', this.getTemplateViewModel(), this.caller)
        this.toolTipPremiumNetCr.setTitle('Net Conversion Rate');
        this.toolTipPremiumNetCr.setContent(toolTipPremiumNetCrContent);

        let toolTipQuizStartRatioContent = `
            <p>Calculated as (Started) / (Loaded)</p>
        `;
        this.toolTipPollStartRatio = new infoButton_template('toolTipPollStartRatio', this.getTemplateViewModel(), this.caller)
        this.toolTipPollStartRatio.setTitle('Start Ratio');
        this.toolTipPollStartRatio.setContent(toolTipQuizStartRatioContent);

        this.toolTipQuizStartRatio = new infoButton_template('toolTipQuizStartRatio', this.getTemplateViewModel(), this.caller)
        this.toolTipQuizStartRatio.setTitle('Start Ratio');
        this.toolTipQuizStartRatio.setContent(toolTipQuizStartRatioContent);

        let toolTipVotesContent = `
            <p>Displayed as (Upvotes) / (Downvotes)</p>
        `;
        this.toolTipVotes = new infoButton_template('toolTipVotes', this.getTemplateViewModel(), this.caller)
        this.toolTipVotes.setTitle('Votes');
        this.toolTipVotes.setContent(toolTipVotesContent);

        this.toolTipRatingVotes = new infoButton_template('toolTipRatingVotes', this.getTemplateViewModel(), this.caller)
        this.toolTipRatingVotes.setTitle('Votes');
        this.toolTipRatingVotes.setContent(toolTipVotesContent);

        let toolTipUniqueArticlesContent = `
            <p>The number of articles which have posts</p>
        `;
        this.toolTipUniqueArticles = new infoButton_template('toolTipUniqueArticles', this.getTemplateViewModel(), this.caller)
        this.toolTipUniqueArticles.setTitle('Articles');
        this.toolTipUniqueArticles.setContent(toolTipUniqueArticlesContent);

        let toolTipTagsContent = `
            <p>The number of tags which have ratings</p>
        `;
        this.toolTipTags = new infoButton_template('toolTipTags', this.getTemplateViewModel(), this.caller)
        this.toolTipTags.setTitle('Tags');
        this.toolTipTags.setContent(toolTipTagsContent);

        let toolTipTotalInteractionsContent = `
            <p>The sum of all interactions for the day</p>
        `;
        this.toolTipTotalInteractions = new infoButton_template('toolTipTotalInteractions', this.getTemplateViewModel(), this.caller)
        this.toolTipTotalInteractions.setTitle('Total Interactions');
        this.toolTipTotalInteractions.setContent(toolTipTotalInteractionsContent);

        let toolTipDynamicEventsContent = `
            <div class="w-mega-tooltip">
                <div class="column">
                    <div class="mega-tooltip-card"><p><strong class="mega-title">Action Bar</strong></p><ul><li><p>DB Homepage Jumplink</p></li><li><p>Threads Homepage Jumplink</p></li><li><p>Follow Topic</p></li><li><p>Like Article</p></li><li><p>Follow Article</p></li><li><p>Follow Author</p></li><li><p>Follow User</p></li></ul></div>
                    <div class="mega-tooltip-card"><p><strong class="mega-title">Action Bar DB Search</strong></p><ul><li><p>Search Submit Click</p></li></ul></div>
                    <div class="mega-tooltip-card"><p><strong class="mega-title">Action Bar Sub-Menu</strong></p><ul><li><p>Jump to Thread Click</p></li><li><p>Sub Menu Open</p></li><li><p>Open Directory Menu</p></li></ul></div>
                    <div class="mega-tooltip-card"><p><strong class="mega-title">Article Featured Section</strong></p><ul><li><p>Jump to Thread Click</p></li><li><p>Follow Article</p></li><li><p>Like Article</p></li></ul></div>
                    <div class="mega-tooltip-card"><p><strong class="mega-title">Author Page</strong></p><ul><li><p>Follow Author</p></li><li><p>Change Date Click</p></li><li><p>Show More Expand Open</p></li></ul></div>
                    <div class="mega-tooltip-card"><p><strong class="mega-title">Channel Schedule</strong></p><ul><li><p>Change Date Click</p></li><li><p>Show More Expand Open</p></li></ul></div>
                    <div class="mega-tooltip-card"><p><strong class="mega-title">Game Ticker</strong></p><ul><li><p>League Dropdown Click</p></li></ul></div>
                    <div class="mega-tooltip-card"><p><strong class="mega-title">Image Group</strong></p><ul><li><p>Hero Image Load</p></li><li><p>Fullscreen Image Load</p></li></ul></div>
                </div>
                <div class="column">
                    <div class="mega-tooltip-card"><p><strong class="mega-title">Listing Filter</strong></p><ul><li><p>Change Results Click</p></li></ul></div>
                    <div class="mega-tooltip-card"><p><strong class="mega-title">My List Page</strong></p><ul><li><p>Adding Element to List</p></li><li><p>Edit List</p></li><li><p>Search Submit Click</p></li></ul></div>
                    <div class="mega-tooltip-card"><p><strong class="mega-title">Rating Carousel Homepage</strong></p><ul><li><p>Rate Tag</p></li><li><p>Like Tag</p></li><li><p>Follow Topic</p></li></ul></div>
                    <div class="mega-tooltip-card"><p><strong class="mega-title">Rating Carousel Promo</strong></p><ul><li><p>Rate Tag</p></li><li><p>Like Tag</p></li><li><p>Follow Topic</p></li></ul></div>
                    <div class="mega-tooltip-card"><p><strong class="mega-title">Review Thread</strong></p><ul><li><p>Sort Thread Comments Click</p></li><li><p>Comment Copy Click</p></li><li><p>Review Thread Post</p></li><li><p>Review Thread Upvote</p></li><li><p>Review Thread Downvote</p></li></ul></div>
                    <div class="mega-tooltip-card"><p><strong class="mega-title">Summary Widget</strong></p><ul><li><p>Generate Summary FactualSummary</p></li><li><p>Generate Summary SimpleSummary</p></li><li><p>Generate Summary SatiricalSummary</p></li></ul></div>
                    <div class="mega-tooltip-card"><p><strong class="mega-title">Tag Display Card</strong></p><ul><li><p>Show More Expand Open</p></li><li><p>Where to Play Open</p></li><li><p>Where to Watch Open</p></li><li><p>Fullscreen Image Load</p></li><li><p>Show More Expand Open</p></li><li><p>Where to Play Open</p></li><li><p>Where to Watch Open</p></li><li><p>Adding Element to List</p></li><li><p>Rate Tag</p></li><li><p>Like Tag</p></li><li><p>Follow Topic</p></li><li><p>Jump to Review</p></li></ul></div>
                </div>
                <div class="column">
                    <div class="mega-tooltip-card"><p><strong class="mega-title">Tag Interaction Menu</strong></p><ul><li><p>Adding Element to List</p></li><li><p>Rate Tag</p></li><li><p>Like Tag</p></li><li><p>Follow Topic</p></li><li><p>Jump to Review</p></li></ul></div>
                    <div class="mega-tooltip-card"><p><strong class="mega-title">Thread</strong></p><ul><li><p>Sort Thread Comments Click</p></li><li><p>Submit Thread Form Submit</p></li><li><p>Comment Copy Click</p></li><li><p>Thread Post</p></li><li><p>Thread Upvote</p></li><li><p>Thread Downvote</p></li></ul></div>
                    <div class="mega-tooltip-card"><p><strong class="mega-title">Trim Comparison</strong></p><ul><li><p>Select First Trim Click]</p></li><li><p>Select Second Trim Search Click</p></li><li><p>Select Second Trim Click</p></li></ul></div>
                    <div class="mega-tooltip-card"><p><strong class="mega-title">User Profile Page</strong></p><ul><li><p>Follow User</p></li><li><p>Rate Tag</p></li></ul></div>
                    <div class="mega-tooltip-card"><p><strong class="mega-title">Website Header</strong></p><ul><li><p>Site Search Submit</p></li></ul></div>
                    <div class="mega-tooltip-card"><p><strong class="mega-title">Website User Card</strong></p><ul><li><p>Follow User</p></li></ul></div>
                </div>
            </div>


        `;
        this.toolTipDynamicEvents = new infoButton_template('toolTipDynamicEvents', this.getTemplateViewModel(), this.caller)
        this.toolTipDynamicEvents.setTitle('Dynamic Events');
        this.toolTipDynamicEvents.setContent(toolTipDynamicEventsContent);

        let toolTipNetSubsContent = `
            <p>Calculated as (Subs.) - (Unsubs.)</p>
        `;
        this.toolTipNetSubs = new infoButton_template('toolTipNetSubs', this.getTemplateViewModel(), this.caller)
        this.toolTipNetSubs.setTitle('Net Subs');
        this.toolTipNetSubs.setContent(toolTipNetSubsContent);
        
        let toolTipNetPageviewPercentContent = `
            <p>Calculated as (Premium Pageviews) / (Total Loggedin Pageviews)</p>
        `;
        this.toolTipNetPageviewPercent = new infoButton_template('toolTipNetPageviewPercent', this.getTemplateViewModel(), this.caller)
        this.toolTipNetPageviewPercent.setTitle('PV %');
        this.toolTipNetPageviewPercent.setContent(toolTipNetPageviewPercentContent);

        let toolTipTotalLoginCrContent = `
            <p>Calculated as (New Accounts + Returning Users, excluding Google OneTap) / LG-IN Loads. Google OneTap is excluded because there is no matching load count available.</p>
        `;
        this.toolTipTotalLoginCr = new infoButton_template('toolTipTotalLoginCr', this.getTemplateViewModel(), this.caller)
        this.toolTipTotalLoginCr.setTitle('Total LG-IN CR');
        this.toolTipTotalLoginCr.setContent(toolTipTotalLoginCrContent);

        let toolTipTagListRatingLoginContent = `
            <p>Includes tag_list and tag_rating.</p>
        `;
        this.toolTipTagListRatingLogin = new infoButton_template('toolTipTagListRatingLogin', this.getTemplateViewModel(), this.caller)
        this.toolTipTagListRatingLogin.setTitle('Tag List & Rating');
        this.toolTipTagListRatingLogin.setContent(toolTipTagListRatingLoginContent);

        let toolTipNewsletterWidgetsLoginContent = `
            <p>Includes Newsletter Floating, Newsletter Article Content Widget, Newsletter Sidebar Widget, Newsletter Homepage Widget, and Newsletter Footer Widget.</p>
        `;
        this.toolTipNewsletterWidgetsLogin = new infoButton_template('toolTipNewsletterWidgetsLogin', this.getTemplateViewModel(), this.caller)
        this.toolTipNewsletterWidgetsLogin.setTitle('Newsletter Widgets');
        this.toolTipNewsletterWidgetsLogin.setContent(toolTipNewsletterWidgetsLoginContent);
    }

    private getLoginPlacementTopHeader(title: string, expandObservable?: string, expandHandler?: string, tooltipHtml?: string): string {
        const colspanBinding = expandObservable ? ` data-bind="attr: { colspan: ${expandObservable}() ? 4 : 1 }"` : ' colspan="4"';
        const expandButton = expandObservable
            ? `<span style="float: right"><button class="icon fix-width i-expand" type="button" data-bind="class: ${expandObservable}ButtonClass(), event: { click: ${expandHandler} }"></button></span>`
            : '';
        const tooltip = tooltipHtml
            ? `<div class="w-tooltips-adv auto-height leadgen-column-header-tooltip">${tooltipHtml}</div>`
            : '';
        const tooltipOpenClass = tooltipHtml ? ' leadgen-tooltip-open' : '';

        return `<th${colspanBinding} class="colgroup-1 start end${tooltipOpenClass}"><span class="align-center">${title}${tooltip}</span>${expandButton}</th>`;
    }

    private getLoginPlacementSubHeaders(expandObservable?: string): string {
        const firstEndClass = expandObservable ? ` data-bind="css: { end: !${expandObservable}() }"` : '';
        const optionalStart = expandObservable ? `<!-- ko if: ${expandObservable}() -->` : '';
        const optionalEnd = expandObservable ? '<!-- /ko -->' : '';

        return `
            <th class="colgroup-1 start"${firstEndClass}><span class="align-right">New Acc.</span></th>
            ${optionalStart}
            <th class="colgroup-1"><span class="align-right">Ret. Users</span></th>
            <th class="colgroup-1"><span class="align-right">LG-IN Loads</span></th>
            <th class="colgroup-1 end"><span class="align-right">LG-IN CR</span></th>
            ${optionalEnd}
        `;
    }

    private getLoginPlacementCells(prefix: string, expandObservable?: string): string {
        const firstEndClass = expandObservable ? ` data-bind="css: { end: !$root.loginStats.${expandObservable}() }"` : '';
        const optionalStart = expandObservable ? `<!-- ko if: $root.loginStats.${expandObservable}() -->` : '';
        const optionalEnd = expandObservable ? '<!-- /ko -->' : '';

        return `
            <td class="align-right colgroup-1 start"${firstEndClass}>
                <span data-bind="text: Number($data.item.${prefix}Registration || 0).toLocaleString('en-EG', {maximumFractionDigits: 0})"></span>
            </td>
            ${optionalStart}
            <td class="align-right colgroup-1">
                <span data-bind="text: Number($data.item.${prefix}Login || 0).toLocaleString('en-EG', {maximumFractionDigits: 0})"></span>
            </td>
            <td class="align-right colgroup-1">
                <span data-bind="text: Number($data.item.${prefix}LoadedLogin || 0).toLocaleString('en-EG', {maximumFractionDigits: 0})"></span>
            </td>
            <td class="align-right colgroup-1 end">
                <span data-bind="text: Number($data.item.${prefix}LoginCr || 0).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span>
            </td>
            ${optionalEnd}
        `;
    }

    protected getTemplateHtml(): string {
        return /*html*/`
            <div class="sub-header w-justify">

               ${this.presetFilter.getHtmlBuild()}

                <div class="w-left">
                
                    <div class="dropdown select-single">
                        <label class="form-label" for="">View Mode</label>
                        <button class="dropdown-toggle" type="button" data-bind="text: viewModeSelectedText"></button>
                        
                        <div class="dropdown-list"> 
                            <div class="w-form">   
                                <div class="form-group" data-bind="foreach: viewModes">
                                    <input type="radio" data-bind="checked : $parent.viewModeSelected, value: id,  attr: { 'id': 'view_' + id, 'name' : 'view_' + id }, event:{ change: $parent.onViewModeChange}">
                                    <label class="form-label" data-bind="attr: {for : 'view_' + id }, text: name"></label>
                                </div>
                            </div>
                        </div>
                    </div>
                   
                    ${this.brandsFilter.getHtmlBuild()}

                    <div data-bind="visible: tabViewModeSelected() !== 'activities' && tabViewModeSelected() !== 'newsletter'">
                        ${this.countriesFilter.getHtmlBuild()}
                    </div>

                    <div data-bind="visible: tabViewModeSelected() === 'login'">
                        <div class="dropdown select-single">
                            <label class="form-label" for="">Device Options</label>
                            <button class="dropdown-toggle" type="button" data-bind="text: deviceOptionSelectedText"></button>

                            <div class="dropdown-list">
                                <div class="w-form">
                                    <div class="form-group" data-bind="foreach: deviceOptions">
                                        <input type="radio" data-bind="checked : $parent.deviceOptionSelected, value: id,  attr: { 'id': 'device_' + id, 'name' : 'device_' + id }, event:{ change: $parent.onDeviceOptionChange}">
                                        <label class="form-label" data-bind="attr: {for : 'device_' + id }, text: name"></label>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    ${this.datesFilter.getHtmlBuild()}
                </div>
            </div>
            
            ${this.validationsList.getHtmlBuild()}

            <div class="w-filters-selected">
                <div id="filters-selected" class="filters-selected">
                   <div id="selected-brands"></div>
                   <div data-bind="visible: tabViewModeSelected() !== 'activities' && tabViewModeSelected() !== 'newsletter'" id="selected-countries"></div>
                </div>
            </div>
            <div class="w-page-tab">
                <div class="page-tab">
                    <button class="btn large icon i-user text-transform-none" data-bind="event: { click: onTabViewModeChange.bind($data, 'login')}, css: {'active': tabViewModeSelected() == 'login'}" >Login</button>
                    <button class="btn large icon i-newsletter text-transform-none" data-bind="event: { click: onTabViewModeChange.bind($data, 'newsletter')}, css: {'active': tabViewModeSelected() == 'newsletter'}">Newsletter</button>
                    <button class="btn large icon i-star-stroke text-transform-none" data-bind="event: { click: onTabViewModeChange.bind($data, 'premium')}, css: {'active': tabViewModeSelected() == 'premium'}">Premium</button>
                    <button class="btn large icon i-thread text-transform-none" data-bind="event: { click: onTabViewModeChange.bind($data, 'activities')}, css: {'active': tabViewModeSelected() == 'activities'}">Interactions</button>
                </div>
            </div> 
            <div class="list-header w-justify">
                <div class="w-left">
                    <h3 class="section-title icon i-user" data-bind="visible: tabViewModeSelected() == 'login'">Login Stats</h3>
                    <h3 class="section-title icon i-newsletter" data-bind="visible: tabViewModeSelected() == 'newsletter'">Newsletter Stats</h3>
                    <h3 class="section-title icon i-star-stroke"  data-bind="visible: tabViewModeSelected() == 'premium'">Premium Stats</h3>
                    <h3 class="section-title icon i-thread"  data-bind="visible: tabViewModeSelected() == 'activities'">Interactions Stats
                        <span class="w-tooltips-adv pos-right large"> 
                            ` + this.toolTipDynamicEvents.getHtmlBuild() + `
                        </span>                      
                    </h3>
                </div>

                ${/*
                AIME-3449 - hidden until we decide to remove it permanently
                <div data-bind="visible: tabViewModeSelected() == 'login'" class="w-center">
                    ${this.permalinkFilter.getHtmlBuild()}
                    <div class="w-tooltips-adv auto-height">
                        ${this.toolTipLoginSearchBar.getHtmlBuild()}
                    </div>
                </div>
                */''}
                <div class="w-right">
                    <div class="highlight-page">
                        <div class="highlight-item">
                            <div class="main">
                                <div class="item-title">Total Accounts</div>
                                <strong class="item-value"><span data-bind="text: isNaN(totalActiveAccounts()) ? '-' : Number(totalActiveAccounts()).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"><span></strong>
                            </div>
                            <div class="sub">
                                <strong class="item-value sub-value"><span data-bind="text: isNaN(totalVerifiedAccounts()) ? '-' : Number(totalVerifiedAccounts()).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"><span></strong>
                                <span class="item-title sub-title">Verified</span>
                            </div>
                        </div>
                        <div class="highlight-item">
                            <div class="main">
                                <div class="item-title">Total Profiles</div>
                                <strong class="item-value"><span data-bind="text: isNaN(totalProfiles()) ? '-' : Number(totalProfiles()).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"><span></strong>
                            </div>
                            <div class="sub">
                                <strong class="item-value sub-value"><span data-bind="text: isNaN(totalIndexedProfiles()) ? '-' : Number(totalIndexedProfiles()).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"><span></strong>
                                <span class="item-title sub-title">Indexed Profiles</span>
                            </div>
                        </div>
                        <div class="highlight-item">
                            <div class="main">
                                <div class="item-title">Total Premium Accounts</div>
                                <strong class="item-value"><span data-bind="text: isNaN(totalPremiumUsers()) ? '-' : Number(totalPremiumUsers()).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"><span></strong>
                                <!--
                                <span class="trials">
                                    <span class="item-title sub-title">
                                    &nbsp;
                                    (<strong class="item-value sub-value" style="color: #085070" data-bind="text: isNaN(totalPremiumTrials()) ? '-' : Number(totalPremiumTrials()).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></strong>
                                    Trials)
                                    </span>
                                -->
                                </span>
                            </div>
                            <div class="sub">
                                <strong class="item-value sub-value"><span data-bind="text: isNaN(monthlyPremiumUsers()) ? '-' : Number(monthlyPremiumUsers()).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"><span></strong>
                                <span class="item-title sub-title">Monthly</span>
                                /
                                <strong class="item-value sub-value"><span data-bind="text: isNaN(yearlyPremiumUsers()) ? '-' : Number(yearlyPremiumUsers()).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"><span></strong>
                                <span class="item-title sub-title">Yearly</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="w-list-results"id="list-results" style="position: relative">
            
                <!-- ko if: viewModeSelected() == "daily" -->                           
                    <table class="list-results list-sections">
                        <thead>
                            <tr>
                                <th></th>
                                <!-- ko template: {name: tabViewModeSelected() == "login" ? 'statsTopHeadersTemplateLogin' : tabViewModeSelected() == "newsletter" ? 'statsTopHeadersTemplateNewsletter' : tabViewModeSelected() == "premium" ? 'statsTopHeadersTemplatePremium' : 'statsTopHeadersTemplateActivities',  data: $data} --><!-- /ko -->
                            </tr>
                            <tr>
                                <th>
                                    <span class="align-right">Date</span>
                                </th>
                                <!-- ko template: {name: tabViewModeSelected() == "login" ? 'statsSubHeadersTemplateLogin' : tabViewModeSelected() == "newsletter" ? 'statsSubHeadersTemplateNewsletter' : tabViewModeSelected() == "premium" ? 'statsSubHeadersTemplatePremium' : 'statsSubHeadersTemplateActivities',  data: $data} --><!-- /ko -->
                            </tr>
                        </thead>
                        <tbody>
                            
                            <!-- ko foreach: loginStatsDaily -->
                            <tr data-bind="event: { click: $parent.onClickRowClick.bind($data, $index(), $data) }, css: { 'is-clicked': $parent.selectedRows().indexOf($index()) !== -1}">
                                <td class="align-right">
                                    <span class="no-wrap" data-bind="text: new Date(date).toLocaleDateString('en-CA', { weekday: 'short', year: 'numeric', month: '2-digit', day: '2-digit' })"></span>
                                </td>
                                <!-- ko template: {name: $parent.tabViewModeSelected() == "login" ? 'statsTemplateLogin' : $parent.tabViewModeSelected() == "newsletter" ? 'statsTemplateNewsletter' : $parent.tabViewModeSelected() == "premium" ? 'statsTemplatePremium' : 'statsTemplateActivities',  data: {item : $data, revenuePermissions : $parent.revenuePermissions}} --><!-- /ko -->
                            </tr>
                            <!-- /ko -->

                            <!-- ko if: loginStatsTotals() != "" -->                           
                            <tr class="total align-right" data-bind="event: { click: onClickRowClick.bind($data, 'total', $data)}, css: { 'is-clicked': selectedRows().indexOf('total') !== -1}">
                                <td>
                                    <span>TOTAL</span>
                                </td>
                                <!-- ko template: {name: tabViewModeSelected() == "login" ? 'statsTemplateLogin' : tabViewModeSelected() == "newsletter" ? 'statsTemplateNewsletter' : tabViewModeSelected() == "premium" ? 'statsTemplatePremium' : 'statsTemplateActivities',  data: {item : $data.loginStatsTotals(), revenuePermissions : $data.revenuePermissions}} --><!-- /ko -->
                            </tr>
                            <!-- /ko -->

                        </tbody>
                    </table>
                <!-- /ko -->
                
                <!-- ko if: viewModeSelected() == "brands" -->       
                    <table class="list-results list-sections">
                        <thead>
                            <tr>
                                <th class="double-column" colspan="2"></th>
                                <!-- ko template: {name: tabViewModeSelected() == "login" ? 'statsTopHeadersTemplateLogin' : tabViewModeSelected() == "newsletter" ? 'statsTopHeadersTemplateNewsletter' : tabViewModeSelected() == "premium" ? 'statsTopHeadersTemplatePremium' : 'statsTopHeadersTemplateActivities',  data: $data} --><!-- /ko -->
                            </tr>
                            <tr>
                                <th class="double-column" colspan="2"></th>
                                <!-- ko template: {name: tabViewModeSelected() == "login" ? 'statsSubHeadersTemplateLogin' : tabViewModeSelected() == "newsletter" ? 'statsSubHeadersTemplateNewsletter' : tabViewModeSelected() == "premium" ? 'statsSubHeadersTemplatePremium' : 'statsSubHeadersTemplateActivities',  data: $data} --><!-- /ko -->
                            </tr>
                        </thead>
                        <tbody>
                            
                            <!-- ko foreach: loginStatsBrands -->
                                <!-- ko foreach: brands -->
                                
                                <tr  data-bind="event: { click: $parents[1].onClickRowClick.bind($data, $parentContext.$index() + '-' + $index(), $data)}, css: { 'is-clicked': $parents[1].selectedRows().indexOf($parentContext.$index() + '-' + $index()) !== -1 }">
                                    <!-- ko if: $index() === 0 -->
                                        <td class="w-group-icon">
                                            <span class="full-icon icon-box" data-bind="css: $parent.iconImage"></span>
                                            <span class="brand-name" data-bind="text: $parent.name"></span>
                                        </td>

                                        <td class="w-brand-icon">
                                            <span data-bind="css: brandIconImage" class="full-icon icon-box"></span>
                                            <span data-bind="text: brandShortName" class="brand-name"></span>
                                        </td>
                                        <!-- ko template: {name: $parents[1].tabViewModeSelected() == "login" ? 'statsTemplateLogin' : $parents[1].tabViewModeSelected() == "newsletter" ? 'statsTemplateNewsletter' : $parents[1].tabViewModeSelected() == "premium" ? 'statsTemplatePremium' : 'statsTemplateActivities',  data: {item : $data, revenuePermissions : $parents[1].revenuePermissions}} --><!-- /ko -->
                                    <!-- /ko -->

                                    <!-- ko ifnot: $index() === 0 -->
                                        <td></td>
                                        <td class="w-brand-icon">
                                            <span data-bind="css: brandIconImage" class="full-icon icon-box"></span>
                                            <span data-bind="text: brandShortName" class="brand-name"></span>
                                        </td>
                                        <!-- ko template: {name: $parents[1].tabViewModeSelected() == "login" ? 'statsTemplateLogin' : $parents[1].tabViewModeSelected() == "newsletter" ? 'statsTemplateNewsletter' : $parents[1].tabViewModeSelected() == "premium" ? 'statsTemplatePremium' : 'statsTemplateActivities',  data: {item : $data, revenuePermissions : $parents[1].revenuePermissions}} --><!-- /ko -->
                                    <!-- /ko -->
                                </tr>

                                <!-- /ko -->

                                <tr class="group-total" data-bind="event: { click: $parent.onClickRowClick.bind($data, 'group-' + $index(), $data)}, css: { 'is-clicked': $parent.selectedRows().indexOf('group-' + $index()) !== -1 }">
                                    <td></td>
                                    <td class="w-group-total">
                                          <span>TOTAL</span>
                                    </td>
                                    <!-- ko template: {name: $parent.tabViewModeSelected() == "login" ? 'statsTemplateLogin' : $parent.tabViewModeSelected() == "newsletter" ? 'statsTemplateNewsletter' : $parent.tabViewModeSelected() == "premium" ? 'statsTemplatePremium' : 'statsTemplateActivities',  data: {item : totals, revenuePermissions : $parent.revenuePermissions}} --><!-- /ko -->
                                </tr>
                            <!-- /ko -->

                            <!-- ko if: loginStatsTotals() != "" -->
                            <tr class="total" data-bind="event: { click: onClickRowClick.bind($data, 'total', $data)}, css: { 'is-clicked': selectedRows().indexOf('total') !== -1 }">
                                <td colspan="2">
                                    <span>TOTAL</span>
                                </td>
                                <!-- ko template: {name: tabViewModeSelected() == "login" ? 'statsTemplateLogin' : tabViewModeSelected() == "newsletter" ? 'statsTemplateNewsletter' : tabViewModeSelected() == "premium" ? 'statsTemplatePremium' : 'statsTemplateActivities',  data: {item : $data.loginStatsTotals(), revenuePermissions : $data.revenuePermissions}} --><!-- /ko -->
                               
                            </tr>
                            <!-- /ko -->
                            
                        </tbody>
                    </table>
                <!-- /ko -->
            </div>
            
            <script type="text/html" id="statsTopHeadersTemplateLogin">
                <th data-bind="attr: { colspan: loginExpandProviders() ? 13 : 7 }" class="colgroup-1 start end">
                    <span class="align-center">Total</span>
                    <span style="float: right"><button class="icon fix-width i-expand" type="button" data-bind="class: loginExpandProvidersButtonClass(), event: { click: onLoginExpandProviders }"></button></span>
                </th>
                <th colspan="9" class="colgroup-1 start end"><span class="align-center">Article Limiter</span></th>
                <th colspan="2" class="colgroup-1 start end"><span class="align-center">Google OneTap</span></th>
                ${this.getLoginPlacementTopHeader('Static', 'loginExpandStatic', 'onLoginExpandStatic')}
                ${this.getLoginPlacementTopHeader('Header', 'loginExpandHeader', 'onLoginExpandHeader')}
                ${this.getLoginPlacementTopHeader('Thread', 'loginExpandThread', 'onLoginExpandThread')}
                ${this.getLoginPlacementTopHeader('Like', 'loginExpandLike', 'onLoginExpandLike')}
                ${this.getLoginPlacementTopHeader('Follow', 'loginExpandFollow', 'onLoginExpandFollow')}
                ${this.getLoginPlacementTopHeader('Quiz', 'loginExpandQuiz', 'onLoginExpandQuiz')}
                ${this.getLoginPlacementTopHeader('Premium', 'loginExpandPremium', 'onLoginExpandPremium')}
                ${this.getLoginPlacementTopHeader('Article Content', 'loginExpandArticleContent', 'onLoginExpandArticleContent')}
                ${this.getLoginPlacementTopHeader('Tag List &amp; Rating', 'loginExpandTagListRating', 'onLoginExpandTagListRating', this.toolTipTagListRatingLogin.getHtmlBuild())}
                ${this.getLoginPlacementTopHeader('Newsletter Widgets', 'loginExpandNewsletterWidgets', 'onLoginExpandNewsletterWidgets', this.toolTipNewsletterWidgetsLogin.getHtmlBuild())}
                <th colspan="4" class="colgroup-4 start end"><span class="align-center">Pageviews</span></th>
                <th colspan="3" class="colgroup-3 start end"><span class="align-center">Impressions</span></th>
                <!-- ko if: $data.revenuePermissions -->
                    <th colspan="5" class="colgroup-2 start end"><span class="align-center">Revenue</span></th>
                <!-- /ko -->
            </script>

            <script type="text/html" id="statsSubHeadersTemplateLogin">
                <th class="colgroup-1 start"><span class="align-right">New Acc.</span></th>
                <th class="colgroup-1"><span class="align-right">Ret. Users</span></th>
                <th class="colgroup-1"><span class="align-right">LG-IN Loads</span></th>
                <th class="colgroup-1 end">
                    <span class="align-right">LG-IN CR
                        <div class="w-tooltips-adv auto-height">
                            ` + this.toolTipTotalLoginCr.getHtmlBuild() + `
                        </div>
                    </span>
                </th>
                <th class="colgroup-1 start"><span class="align-right">Email</span></th>
                <th class="colgroup-1"><span class="align-right">Google</span></th>
                <th class="colgroup-1 end"><span class="align-right">OpenPass</span></th>
                <!-- ko if: loginExpandProviders() -->
                <th class="colgroup-1 start"><span class="align-right">Amazon</span></th>
                <th class="colgroup-1"><span class="align-right">Apple</span></th>
                <th class="colgroup-1"><span class="align-right">Discord</span></th>
                <th class="colgroup-1"><span class="align-right">Facebook</span></th>
                <th class="colgroup-1"><span class="align-right">Steam</span></th>
                <th class="colgroup-1 end"><span class="align-right">Twitch</span></th>
                <!-- /ko -->

                <th class="colgroup-1 start"><span class="align-right">New Acc.</span></th>
                <th class="colgroup-1"><span class="align-right">Ret. Users</span></th>
                <th class="colgroup-1"><span class="align-right">LG-IN Loads</span></th>
                <th class="colgroup-1"><span class="align-right">LG-IN Loads/PV</span></th>
                <th class="colgroup-1"><span class="align-right">Landing PG Loads</span></th>
                <th class="colgroup-1"><span class="align-right">PG 2+ Loads</span></th>
                <th class="colgroup-1">
                    <span class="align-right">Net CR
                        <div class="w-tooltips-adv auto-height">
                            ` + this.toolTipLoginNetCr.getHtmlBuild() + `
                        </div>
                    </span>
                </th>
                <th class="colgroup-1"><span class="align-right">Dismissed</span></th>
                <th class="colgroup-1 end"><span class="align-right">Dismissed%</span></th>

                <th class="colgroup-1 start"><span class="align-right">New Acc.</span></th>
                <th class="colgroup-1 end"><span class="align-right">Ret. Users</span></th>

                ${this.getLoginPlacementSubHeaders('loginExpandStatic')}
                ${this.getLoginPlacementSubHeaders('loginExpandHeader')}
                ${this.getLoginPlacementSubHeaders('loginExpandThread')}
                ${this.getLoginPlacementSubHeaders('loginExpandLike')}
                ${this.getLoginPlacementSubHeaders('loginExpandFollow')}
                ${this.getLoginPlacementSubHeaders('loginExpandQuiz')}
                ${this.getLoginPlacementSubHeaders('loginExpandPremium')}
                ${this.getLoginPlacementSubHeaders('loginExpandArticleContent')}
                ${this.getLoginPlacementSubHeaders('loginExpandTagListRating')}
                ${this.getLoginPlacementSubHeaders('loginExpandNewsletterWidgets')}

                <th class="colgroup-4 start"><span class="align-right">Total</span></th>
                <th class="colgroup-4"><span class="align-right">LG-IN PV%</span></th>
                <th class="colgroup-4"><span class="align-right">ID PV%</span></th>
                <th class="colgroup-4 end"><span class="align-right">Auth. PV%</span></th>

                <th class="colgroup-3 start"><span class="align-right">LG-IN Imp.</span></th>
                <th class="colgroup-3"><span class="align-right">LG-IN Imp.%</span></th>
                <th class="colgroup-3 end"><span class="align-right">LG-IN Imp./Sess</span></th>

                <!-- ko if: $data.revenuePermissions -->
                <th class="colgroup-2 start"><span class="align-right">LG-IN Rev.</span></th>
                <th class="colgroup-2 "><span class="align-right">LG-IN Rev. %</span></th>
                <th class="colgroup-2 "><span class="align-right">LG-IN CPM</span></th>
                <th class="colgroup-2 "><span class="align-right">LG-IN RPM</span></th>
                <th class="colgroup-2 end"><span class="align-right">LG-IN SV</span></th>
                <!-- /ko -->
            </script>


            <script type="text/html" id="statsTemplateLogin">
                <td class="align-right colgroup-1 start"><span data-bind="text: Number($data.item.newMembers || 0).toLocaleString('en-EG')"></span></td>
                <td class="align-right colgroup-1"><span data-bind="text: Number($data.item.totalLogin || 0).toLocaleString('en-EG')"></span></td>
                <td class="align-right colgroup-1"><span data-bind="text: Number($data.item.loadedLogin || 0).toLocaleString('en-EG')"></span></td>
                <td class="align-right colgroup-1 end"><span data-bind="text: Number($data.item.loadedLoginCr || 0).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                <td class="align-right colgroup-1 start"><span data-bind="text: Number($data.item.emailSignups || 0).toLocaleString('en-EG')"></span></td>
                <td class="align-right colgroup-1"><span data-bind="text: Number($data.item.googleSignups || 0).toLocaleString('en-EG')"></span></td>
                <td class="align-right colgroup-1 end"><span data-bind="text: Number($data.item.openPassSignups || 0).toLocaleString('en-EG')"></span></td>
                <!-- ko if: $root.loginStats.loginExpandProviders() -->
                <td class="align-right colgroup-1 start"><span data-bind="text: Number($data.item.amazonSignups || 0).toLocaleString('en-EG')"></span></td>
                <td class="align-right colgroup-1"><span data-bind="text: Number($data.item.appleSignups || 0).toLocaleString('en-EG')"></span></td>
                <td class="align-right colgroup-1"><span data-bind="text: Number($data.item.newDiscordMembers || 0).toLocaleString('en-EG')"></span></td>
                <td class="align-right colgroup-1"><span data-bind="text: Number($data.item.newFacebookMembers || 0).toLocaleString('en-EG')"></span></td>
                <td class="align-right colgroup-1"><span data-bind="text: Number($data.item.steamSignups || 0).toLocaleString('en-EG')"></span></td>
                <td class="align-right colgroup-1 end"><span data-bind="text: Number($data.item.twitchSignups || 0).toLocaleString('en-EG')"></span></td>
                <!-- /ko -->

                <td class="align-right colgroup-1 start"><span data-bind="text: Number($data.item.articleLimitDrawerRegistration || 0).toLocaleString('en-EG')"></span></td>
                <td class="align-right colgroup-1"><span data-bind="text: Number($data.item.articleLimitDrawerLogin || 0).toLocaleString('en-EG')"></span></td>
                <td class="align-right colgroup-1"><span data-bind="text: Number($data.item.articleLimitDrawerEvent || 0).toLocaleString('en-EG')"></span></td>
                <td class="align-right colgroup-1"><span data-bind="text: Number($data.item.articleLimitDrawerPerPageview || 0).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                <td class="align-right colgroup-1"><span data-bind="text: Number($data.item.articleLimitDrawerLandingPG || 0).toLocaleString('en-EG')"></span></td>
                <td class="align-right colgroup-1"><span data-bind="text: Number($data.item.articleLimitDrawerPage2Plus || 0).toLocaleString('en-EG')"></span></td>
                <td class="align-right colgroup-1"><span data-bind="text: Number($data.item.articleLimitDrawerNetCR || 0).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                <td class="align-right colgroup-1"><span data-bind="text: Number($data.item.articleLimitDrawerDismissed || 0).toLocaleString('en-EG')"></span></td>
                <td class="align-right colgroup-1 end"><span data-bind="text: Number($data.item.articleLimitDrawerDismissedPerEvents || 0).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>

                <td class="align-right colgroup-1 start"><span data-bind="text: Number($data.item.googleOneTapRegistration || 0).toLocaleString('en-EG')"></span></td>
                <td class="align-right colgroup-1 end"><span data-bind="text: Number($data.item.googleOneTapLogin || 0).toLocaleString('en-EG')"></span></td>

                ${this.getLoginPlacementCells('static', 'loginExpandStatic')}
                ${this.getLoginPlacementCells('header', 'loginExpandHeader')}
                ${this.getLoginPlacementCells('thread', 'loginExpandThread')}
                ${this.getLoginPlacementCells('like', 'loginExpandLike')}
                ${this.getLoginPlacementCells('follow', 'loginExpandFollow')}
                ${this.getLoginPlacementCells('quiz', 'loginExpandQuiz')}
                ${this.getLoginPlacementCells('premium', 'loginExpandPremium')}
                ${this.getLoginPlacementCells('articleContent', 'loginExpandArticleContent')}
                ${this.getLoginPlacementCells('tagListRating', 'loginExpandTagListRating')}
                ${this.getLoginPlacementCells('newsletterWidgets', 'loginExpandNewsletterWidgets')}

                <td class="align-right colgroup-4 start"><span data-bind="text: Number($data.item.pageviews || 0).toLocaleString('en-EG')"></span></td>
                <td class="align-right colgroup-4"><span data-bind="text: Number($data.item.pageviewsLoggedInRatio || 0).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                <td class="align-right colgroup-4"><span data-bind="text: Number($data.item.pageviewsIdentifiedRatio || 0).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                <td class="align-right colgroup-4 end"><span data-bind="text: Number($data.item.pageviewsAuthenticatedRatio || 0).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                <td class="align-right colgroup-3 start"><span data-bind="text: Number($data.item.impressionsLoggedIn || 0).toLocaleString('en-EG')"></span></td>
                <td class="align-right colgroup-3"><span data-bind="text: Number($data.item.impressionsLoggedInRatio || 0).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                <td class="align-right colgroup-3 end"><span data-bind="text: Number($data.item.loggedInImpPerSession || 0).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                <!-- ko if: $data.revenuePermissions -->
                <td class="align-right colgroup-2 start"><span data-bind="text: '$' + Number($data.item.revenueLoggedIn || 0).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                <td class="align-right colgroup-2"><span data-bind="text: Number($data.item.revenueLoggedInRatio || 0).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                <td class="align-right colgroup-2"><span class="no-wrap" data-bind="text: Number($data.item.loggedInCpm || 0).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + ' (' + ((($data.item.loggedInCpm - $data.item.nonLoggedInCpm) >= 0) ? '+' : '') + Number($data.item.loggedInCpm - $data.item.nonLoggedInCpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + ')'"></span></td>
                <td class="align-right colgroup-2"><span class="no-wrap" data-bind="text: Number($data.item.loggedInRpm || 0).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + ' (' + ((($data.item.loggedInRpm - $data.item.nonLoggedInRpm) >= 0) ? '+' : '') + Number($data.item.loggedInRpm - $data.item.nonLoggedInRpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + ')'"></span></td>
                <td class="align-right colgroup-2 end"><span class="no-wrap" data-bind="text: Number($data.item.loggedInSv || 0).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + ' (' + ((($data.item.loggedInSv - $data.item.nonLoggedInSv) >= 0) ? '+' : '') + Number($data.item.loggedInSv - $data.item.nonLoggedInSv).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + ')'"></span></td>
                <!-- /ko -->
            </script>

            <script type="text/html" id="statsTopHeadersTemplateNewsletter">
                <th colspan="5" class="colgroup-1 start end"><span class="align-center">Total</span></th>
                <th colspan="3" class="colgroup-1 start end"><span class="align-center">Registration Form</span></th>
                <th colspan="3" class="colgroup-1 start end"><span class="align-center">Static</span></th>
                <th colspan="3" class="colgroup-1 start end"><span class="align-center">Newsletter Floating</span></th>
                <th colspan="3" class="colgroup-1 start end"><span class="align-center">Newsletter Article Content Widget</span></th>
                <th colspan="3" class="colgroup-1 start end"><span class="align-center">Newsletter Sidebar Widget</span></th>
                <th colspan="3" class="colgroup-1 start end"><span class="align-center">Newsletter Homepage Widget</span></th>
                <th colspan="3" class="colgroup-1 start end"><span class="align-center">Newsletter Footer Widget</span></th>
            </script>

            <script type="text/html" id="statsSubHeadersTemplateNewsletter">
                <th class="colgroup-1 start"><span class="align-right">Subs</span></th>
                <th class="colgroup-1"><span class="align-right">Unsubs</span></th>
                <th class="colgroup-1"><span class="align-right">Delta</span></th>
                <th class="colgroup-1"><span class="align-right">NL Loads</span></th>
                <th class="colgroup-1 end"><span class="align-right">NL CR</span></th>
                <!-- ko foreach: [1, 2, 3, 4, 5, 6, 7] -->
                <th class="colgroup-1 start"><span class="align-right">Subs</span></th>
                <th class="colgroup-1"><span class="align-right">NL Loads</span></th>
                <th class="colgroup-1 end"><span class="align-right">NL CR</span></th>
                <!-- /ko -->
            </script>

            <script type="text/html" id="statsTemplateNewsletter">
                <td class="align-right colgroup-1 start"><span data-bind="text: Number($data.item.newsletterUniqueSubscribers || 0).toLocaleString('en-EG')"></span></td>
                <td class="align-right colgroup-1"><span data-bind="text: Number($data.item.newsletterUniqueUnsubscribers || 0).toLocaleString('en-EG')"></span></td>
                <td class="align-right colgroup-1"><span data-bind="text: Number($data.item.newsletterUniqueDelta || 0).toLocaleString('en-EG')"></span></td>
                <td class="align-right colgroup-1"><span data-bind="text: Number($data.item.loadedNewsletter || 0).toLocaleString('en-EG')"></span></td>
                <td class="align-right colgroup-1 end"><span data-bind="text: Number($data.item.newsletterUniqueCr || 0).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                <td class="align-right colgroup-1 start"><span data-bind="text: Number($data.item.newsletterRegistrationFormSubscriptions || 0).toLocaleString('en-EG')"></span></td>
                <td class="align-right colgroup-1"><span data-bind="text: Number($data.item.newsletterRegistrationFormLoaded || 0).toLocaleString('en-EG')"></span></td>
                <td class="align-right colgroup-1 end"><span data-bind="text: Number($data.item.newsletterRegistrationFormCr || 0).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                <td class="align-right colgroup-1 start"><span data-bind="text: Number($data.item.newsletterStaticSubscriptions || 0).toLocaleString('en-EG')"></span></td>
                <td class="align-right colgroup-1"><span data-bind="text: Number($data.item.newsletterStaticLoaded || 0).toLocaleString('en-EG')"></span></td>
                <td class="align-right colgroup-1 end"><span data-bind="text: Number($data.item.newsletterStaticCr || 0).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                <td class="align-right colgroup-1 start"><span data-bind="text: Number($data.item.newsletterFloatingSubscriptions || 0).toLocaleString('en-EG')"></span></td>
                <td class="align-right colgroup-1"><span data-bind="text: Number($data.item.newsletterFloatingLoaded || 0).toLocaleString('en-EG')"></span></td>
                <td class="align-right colgroup-1 end"><span data-bind="text: Number($data.item.newsletterFloatingCr || 0).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                <td class="align-right colgroup-1 start"><span data-bind="text: Number($data.item.newsletterArticleContentSubscriptions || 0).toLocaleString('en-EG')"></span></td>
                <td class="align-right colgroup-1"><span data-bind="text: Number($data.item.newsletterArticleContentLoaded || 0).toLocaleString('en-EG')"></span></td>
                <td class="align-right colgroup-1 end"><span data-bind="text: Number($data.item.newsletterArticleContentCr || 0).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                <td class="align-right colgroup-1 start"><span data-bind="text: Number($data.item.newsletterSidebarSubscriptions || 0).toLocaleString('en-EG')"></span></td>
                <td class="align-right colgroup-1"><span data-bind="text: Number($data.item.newsletterSidebarLoaded || 0).toLocaleString('en-EG')"></span></td>
                <td class="align-right colgroup-1 end"><span data-bind="text: Number($data.item.newsletterSidebarCr || 0).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                <td class="align-right colgroup-1 start"><span data-bind="text: Number($data.item.newsletterHomepageSubscriptions || 0).toLocaleString('en-EG')"></span></td>
                <td class="align-right colgroup-1"><span data-bind="text: Number($data.item.newsletterHomepageLoaded || 0).toLocaleString('en-EG')"></span></td>
                <td class="align-right colgroup-1 end"><span data-bind="text: Number($data.item.newsletterHomepageCr || 0).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                <td class="align-right colgroup-1 start"><span data-bind="text: Number($data.item.newsletterFooterSubscriptions || 0).toLocaleString('en-EG')"></span></td>
                <td class="align-right colgroup-1"><span data-bind="text: Number($data.item.newsletterFooterLoaded || 0).toLocaleString('en-EG')"></span></td>
                <td class="align-right colgroup-1 end"><span data-bind="text: Number($data.item.newsletterFooterCr || 0).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
            </script>

            <script type="text/html" id="statsTopHeadersTemplatePremium">
                <th colspan="6" class="colgroup-1 start end"><span class="align-center">Total</span></th>
                <th colspan="4" class="colgroup-1 start end"><span class="align-center">Blocker</span></th>
                <th colspan="3" class="colgroup-4 start end"><span class="align-center">Pageviews</span></th>
                <!-- ko if: $data.revenuePermissions -->
                    <th colspan="4" class="colgroup-2 start end"><span class="align-center">Revenue</span></th>
                <!-- /ko -->
            </script>

            <script type="text/html" id="statsSubHeadersTemplatePremium">
                <th class="colgroup-1 start"><span class="align-right">Subs.</span></th>
                <th class="colgroup-1"><span class="align-right">Monthly</span></th>
                <th class="colgroup-1"><span class="align-right">Yearly</span></th>
                <th class="colgroup-1"><span class="align-right">Unsubs.</span></th>
                <th class="colgroup-1"><span class="align-right">Subs. Ended</span></th>
                <th class="colgroup-1 end">
                    <span class="align-right">Net Subs
                        <div class="w-tooltips-adv auto-height">
                                ` + this.toolTipNetSubs.getHtmlBuild() + `
                        </div>
                    </span>
                </th>

                <th class="colgroup-1 start"><span class="align-right">New Acc.</span></th>
                <th class="colgroup-1"><span class="align-right">Ret. Logins</span></th>
                <th class="colgroup-1"><span class="align-right">Blocker Events</span></th>
                <th class="colgroup-1 end">
                    <span class="align-right">Net CR
                        <div class="w-tooltips-adv auto-height">
                            ` + this.toolTipPremiumNetCr.getHtmlBuild() + `
                        </div>
                    </span>
                </th>

                <th class="colgroup-4 start"><span class="align-right">Total</span></th>
                <th class="colgroup-4"><span class="align-right">Premium PV</span></th>
                <th class="colgroup-4 end">
                    <span class="align-right">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; PV %
                        <div class="w-tooltips-adv auto-height">
                                ` + this.toolTipNetPageviewPercent.getHtmlBuild() + `
                        </div>
                    </span>
                </th>
                <!-- ko if: $data.revenuePermissions -->
                <th class="colgroup-2 start"><span class="align-right">Total</span></th>
                <th class="colgroup-2"><span class="align-right">First Payment</span></th>
                <th class="colgroup-2"><span class="align-right">Recurring Payment</span></th>
                <th class="colgroup-2 end"><span class="align-right">Revenue %</span></th>
                <!-- /ko -->
            </script>


            <script type="text/html" id="statsTemplatePremium">
                <td class="align-right colgroup-1 start end">
                    <span data-bind="text: Number($data.item.newSubsPremium).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})">
                </td>
                <td class="align-right colgroup-1 start">
                    <span data-bind="text: Number($data.item.newMonthlySubsPremium).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})">
                </td>
                <td class="align-right colgroup-1 end">
                    <span data-bind="text: Number($data.item.newYearlySubsPremium).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})">
                </td>
                <td class="align-right colgroup-1 start">
                    <span data-bind="text: Number($data.item.unsubsPremium).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})">
                </td>
                <td class="align-right colgroup-1">
                    <span data-bind="text: Number($data.item.subsEndedPremium).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})">
                </td>
                <td class="align-right colgroup-1 end">
                    <span data-bind="text: Number($data.item.netSubsPremium).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})">
                </td>

                <td class="align-right colgroup-1 start">
                    <span data-bind="text: Number($data.item.blockerRegistration).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})">
                </td>
                <td class="align-right colgroup-1">
                    <span data-bind="text: Number($data.item.blockerLogin).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})">
                </td>
                <td class="align-right colgroup-1">
                    <span data-bind="text: Number($data.item.blockerFreeUserEvent).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})">
                </td>
                <td class="align-right colgroup-1 end">
                    <span data-bind="text: Number($data.item.blockerNetCR).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'">
                </td>


                <td class="align-right colgroup-4 start">
                    <span data-bind="text: Number($data.item.pageviews).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})">
                </td>
                <td class="align-right colgroup-4">
                    <span data-bind="text: Number($data.item.pageviewsPremium).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})">
                </td>
                <td class="align-right colgroup-4 end">
                    <span data-bind="text: Number($data.item.pageviewsPremiumRatio).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'">
                </td>
                
                <!-- ko if: $data.revenuePermissions -->
                    <td class="align-right colgroup-2 start">
                        <span data-bind="text: '$' + Number($data.item.revenuePremium).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})">
                    </td>
                    <td class="align-right colgroup-2">
                        <span data-bind="text: '$' + Number($data.item.revenuePremiumFirstTimePayment).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})">
                    </td>
                    <td class="align-right colgroup-2">
                        <span data-bind="text: '$' + Number($data.item.revenuePremiumRecurringPayment).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})">
                    </td>
                    <td class="align-right colgroup-2">
                        <span data-bind="text: Number($data.item.revenuePremiumRatio).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'">
                    </td>
                <!-- /ko -->
            </script>

            <script type="text/html" id="statsTopHeadersTemplateActivities">
                <th colspan="1" class="colgroup-3 start end"><span class="align-center">Interactions</span></th>
                <!-- ko if: dynamicEventNames().length > 0 -->
                    <th style="z-index:1" data-bind="attr: { colspan: dynamicEventNames().length + 1 }" class="colgroup-2 start end"><span class="align-center">Dynamic Events
                                  
                        </span>
                    </th>
                <!-- /ko -->
                <th data-bind="attr: { colspan: activitiesExpandThreads() ? 8 : 1 }" class="colgroup-1 start end"><span class="align-center">Threads</span><span style="float: right"><button class="icon fix-width i-expand" type="button" data-bind="class: activitiesExpandThreadsButtonClass(), event: { click: onActivitiesExpandThreads }"></button></span></th>
                <th data-bind="attr: { colspan: activitiesExpandFollows() ? 5 : 1 }" class="colgroup-4 start end"><span class="align-center">Follows</span><span style="float: right"><button class="icon fix-width i-expand" type="button" data-bind="class: activitiesExpandFollowsButtonClass(), event: { click: onActivitiesExpandFollows }"></button></span></th>
                <th data-bind="attr: { colspan: activitiesExpandRatings() ? 6 : 1 }" class="colgroup-2 start end"><span class="align-center">Ratings</span><span style="float: right"><button class="icon fix-width i-expand" type="button" data-bind="class: activitiesExpandRatingsButtonClass(), event: { click: onActivitiesExpandRatings }"></button></span></th>
                <th data-bind="attr: { colspan: activitiesExpandMyLists() ? 3 : 1 }" class="colgroup-5 start end"><span class="align-center">My Lists</span><span style="float: right"><button class="icon fix-width i-expand" type="button" data-bind="class: activitiesExpandMyListsButtonClass(), event: { click: onActivitiesExpandMyLists }"></button></span></th>
                <th data-bind="attr: { colspan: activitiesExpandLikes() ? 3 : 1 }" class="colgroup-3 start end"><span class="align-center">Likes</span><span style="float: right"><button class="icon fix-width i-expand" type="button" data-bind="class: activitiesExpandLikesButtonClass(), event: { click: onActivitiesExpandLikes }"></button></span></th>
                <th data-bind="attr: { colspan: activitiesExpandPoll() ? 6 : 1 }" class="colgroup-2 start end"><span class="align-center">Poll</span><span style="float: right"><button class="icon fix-width i-expand" type="button" data-bind="class: activitiesExpandPollButtonClass(), event: { click: onActivitiesExpandPoll }"></button></span></th>
                <th data-bind="attr: { colspan: activitiesExpandSection4() ? 8 : 1 }" class="colgroup-5 start end"><span class="align-center">Quiz</span><span style="float: right"><button class="icon fix-width i-expand" type="button" data-bind="class: activitiesExpandSection4ButtonClass(), event: { click: onActivitiesExpandSection4 }"></button></span></th>
                <th data-bind="attr: { colspan: activitiesExpandCarMarketplace() ? 9 : 1 }" class="colgroup-4 start end"><span class="align-center">Car Marketplace</span><span style="float: right"><button class="icon fix-width i-expand" type="button" data-bind="class: activitiesExpandCarMarketplaceButtonClass(), event: { click: onActivitiesExpandCarMarketplace }"></button></span></th>
                <th colspan="1" class="colgroup-6 start end"><span class="align-center">Pageviews</span></th>
            </script>
            

            <script type="text/html" id="statsSubHeadersTemplateActivities">
                <th class="colgroup-3 start end" style="z-index: 1">
                    <span class="align-right">Total
                        <div class="w-tooltips-adv pos-right auto-height"> 
                                ` + this.toolTipTotalInteractions.getHtmlBuild() + `
                        </div>
                    </span>
                </th>
                <!-- ko if: dynamicEventNames().length > 0 -->
                <th class="colgroup-2 start"><span class="align-right">Total</span></th>
                <!-- /ko -->

                <!-- ko foreach: dynamicEventNames() -->
                <th colspan="1" class="colgroup-2"><span class="align-center" data-bind="text: $data"></span></th>
                <!-- /ko -->

                <th class="colgroup-1 start" data-bind="css: { end: !activitiesExpandThreads() }"><span class="align-right">Total</span></th>
                <!-- ko if: activitiesExpandThreads() -->
                <th class="colgroup-1"><span class="align-right">Posts</span></th>
                <th class="colgroup-1"><span class="align-right">Approved</span></th>
                <th class="colgroup-1"><span class="align-right">Suggested</span></th>
                <th class="colgroup-1"><span class="align-right">Replies</span></th>
                <th class="colgroup-1"><span class="align-right">Mentions</span></th>
                <th class="colgroup-1"><span class="align-right">Votes
                        <div class="w-tooltips-adv auto-height">
                            ` + this.toolTipVotes.getHtmlBuild() + `
                        </div>
                    </span>
                </th>
                <th class="colgroup-1 end"><span class="align-right">Pinned</span></th>
                <!-- /ko -->
                <!-- <th class="colgroup-1 end">
                    <span class="align-right">Articles
                        <div class="w-tooltips-adv auto-height">
                                ` + this.toolTipUniqueArticles.getHtmlBuild() + `
                        </div>
                    </span>
                </th> -->


                <th class="colgroup-4 start" data-bind="css: { end: !activitiesExpandFollows() }"><span class="align-right">Total</span></th>
                <!-- ko if: activitiesExpandFollows() -->
                <th class="colgroup-4"><span class="align-right">Article</span></th>
                <th class="colgroup-4"><span class="align-right">Hub</span></th>
                <th class="colgroup-4"><span class="align-right">Author</span></th>
                <th class="colgroup-4 end"><span class="align-right">Threads</span></th>
                <!-- /ko -->

                <th class="colgroup-2 start" data-bind="css: { end: !activitiesExpandRatings() }"><span class="align-right">Total</span></th>
                <!-- ko if: activitiesExpandRatings() -->
                <th class="colgroup-2"><span class="align-right">Ratings</span></th>
                <th class="colgroup-2"><span class="align-right">Reviews</span></th>
                <th class="colgroup-2"><span class="align-right">Approved</span></th>
                <th class="colgroup-2"><span class="align-right">Votes
                        <div class="w-tooltips-adv auto-height">
                            ` + this.toolTipRatingVotes.getHtmlBuild() + `
                        </div>
                    </span>
                </th>
                <th class="colgroup-2 end"><span class="align-right">Tags
                        <div class="w-tooltips-adv auto-height">
                                ` + this.toolTipTags.getHtmlBuild() + `
                        </div>
                    </span>
                </th>
                <!-- /ko -->

                <th class="colgroup-5 start" data-bind="css: { end: !activitiesExpandMyLists() }"><span class="align-right">Total</span></th>
                <!-- ko if: activitiesExpandMyLists() -->
                <th class="colgroup-5"><span class="align-right">Lists Started</span></th>
                <th class="colgroup-5 end"><span class="align-right">Items Added</span></th>
                <!-- /ko -->
                
                <th class="colgroup-3 start" data-bind="css: { end: !activitiesExpandLikes() }"><span class="align-right">Total</span></th>
                <!-- ko if: activitiesExpandLikes() -->
                <th class="colgroup-3"><span class="align-right">Article</span></th>
                <th class="colgroup-3 end"><span class="align-right">Tag</span></th>
                <!-- /ko -->
                <th class="colgroup-2 start" data-bind="css: { end: !activitiesExpandPoll() }"><span class="align-right">Total</span></th>
                <!-- ko if: activitiesExpandPoll() -->
                <th class="colgroup-2"><span class="align-right">Loaded</span></th>
                <th class="colgroup-2"><span class="align-right">Started</span></th>
                <th class="colgroup-2"><span class="align-right">Start Ratio
                        <div class="w-tooltips-adv auto-height">
                            ` + this.toolTipPollStartRatio.getHtmlBuild() + `
                        </div>
                    </span>
                </th>
                <th class="colgroup-2"><span class="align-right">Answered Question</span></th>
                <th class="colgroup-2 end"><span class="align-right">Completed</span></th>
                <!-- /ko -->
                <th class="colgroup-5 start" data-bind="css: { end: !activitiesExpandSection4() }"><span class="align-right">Total</span></th>
                <!-- ko if: activitiesExpandSection4() -->
                <th class="colgroup-5"><span class="align-right">Loaded</span></th>
                <th class="colgroup-5"><span class="align-right">Started</span></th>
                <th class="colgroup-5"><span class="align-right">Start Ratio
                        <div class="w-tooltips-adv auto-height">
                            ` + this.toolTipQuizStartRatio.getHtmlBuild() + `
                        </div>
                    </span>
                </th>
                <th class="colgroup-5"><span class="align-right">Answered Question</span></th>
                <th class="colgroup-5"><span class="align-right">Completed</span></th>
                <th class="colgroup-5"><span class="align-right">Restarted</span></th>
                <th class="colgroup-5 end"><span class="align-right">Jumped to Thread</span></th>
                <!-- /ko -->
                <th class="colgroup-4 start" data-bind="css: { end: !activitiesExpandCarMarketplace() }"><span class="align-right">Total</span></th>
                <!-- ko if: activitiesExpandCarMarketplace() -->
                <th class="colgroup-4"><span class="align-right">Partner DB</span></th>
                <th class="colgroup-4"><span class="align-right">Partner Homepage</span></th>
                <th class="colgroup-4"><span class="align-right">Partner Marketplace</span></th>
                <th class="colgroup-4"><span class="align-right">Partner PriceTrend</span></th>
                <th class="colgroup-4"><span class="align-right">Partner Carousel</span></th>
                <th class="colgroup-4"><span class="align-right">Marketplace Int.</span></th>
                <th class="colgroup-4"><span class="align-right">Price Trend Int.</span></th>
                <th class="colgroup-4 end"><span class="align-right">Listings Carousel Int.</span></th>
                <!-- /ko -->
                <th class="colgroup-6 start end"><span class="align-right">Total</span></th>
            </script>

            <script type="text/html" id="statsTemplateActivities">
                <td class="align-right colgroup-3 start end">
                    <span data-bind="text: Number($data.item.totalInteractions).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})">
                </td>

                <!-- ko if: $root.loginStats.dynamicEventNames().length > 0 -->
                <td class="align-right colgroup-2 start end">
                    <span data-bind="text: Number($data.item.totalDynamicEventInteractions).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})">
                </td>
                <!-- /ko -->
                <!-- ko foreach: $root.loginStats.dynamicEventNames() -->
                <td class="align-right colgroup-2 start end">
                    <span data-bind="text: Number($parent.item[$data]).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})">
                </td>
                <!-- /ko -->

                <td class="align-right colgroup-1 start" data-bind="css: { end: !$root.loginStats.activitiesExpandThreads() }">
                    <span data-bind="text: Number($data.item.totalThreadInteractions).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})">
                </td>
                <!-- ko if: $root.loginStats.activitiesExpandThreads() -->
                <td class="align-right colgroup-1 start">
                    <span data-bind="text: Number($data.item.totalComments).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})">
                </td>
                <td class="align-right colgroup-1 end">
                    <span data-bind="text: Number($data.item.approvedCommentsRatio).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'">
                </td>
                <td class="align-right colgroup-1">
                    <span data-bind="text: Number($data.item.totalSuggestedThreads).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})">
                </td>
                <td class="align-right colgroup-1">
                    <span data-bind="text: Number($data.item.repliesComments).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})">
                </td>
                <td class="align-right colgroup-1">
                    <span data-bind="text: Number($data.item.mentionsComments).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})">
                </td>
                <td class="align-right colgroup-1">
                    <span data-bind="text: Number($data.item.upvotesComments).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0}) + '/'
                                         + Number($data.item.downvotesComments).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})">
                </td>
                <td class="align-right colgroup-1 end">
                    <span data-bind="text: Number($data.item.pinnedComments).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})">
                </td>
                <!-- /ko -->
                <!-- <td class="align-right colgroup-1 end">
                    <span data-bind="text: Number($data.item.uniqueArticleComments).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})">
                </td> -->

                <td class="align-right colgroup-4 start" data-bind="css: { end: !$root.loginStats.activitiesExpandFollows() }">
                    <span data-bind="text: Number($data.item.totalFollowInteractions).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})">
                </td>
                <!-- ko if: $root.loginStats.activitiesExpandFollows() -->
                <td class="align-right colgroup-4">
                    <span data-bind="text: Number($data.item.articleFollows).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})">
                </td>
                <td class="align-right colgroup-4">
                    <span data-bind="text: Number($data.item.hubFollows).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})">
                </td>
                <td class="align-right colgroup-4">
                    <span data-bind="text: Number($data.item.authorFollows).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})">
                </td>
                <td class="align-right colgroup-4 end">
                    <span data-bind="text: Number($data.item.threadFollows).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})">
                </td>
                <!-- /ko -->

                
                <td class="align-right colgroup-2 start" data-bind="css: { end: !$root.loginStats.activitiesExpandRatings() }">
                    <span data-bind="text: Number($data.item.totalRatingInteractions).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})">
                </td>
                <!-- ko if: $root.loginStats.activitiesExpandRatings() -->
                <td class="align-right colgroup-2">
                    <span data-bind="text: Number($data.item.ratingComments).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})">
                </td>
                <td class="align-right colgroup-2 start">
                    <span data-bind="text: Number($data.item.totalReviews).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})">
                </td>
                <td class="align-right colgroup-2 end">
                    <span data-bind="text: Number($data.item.approvedReviewsRatio).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'">
                </td>
                <td class="align-right colgroup-2">
                    <span data-bind="text: Number($data.item.upvotesReviews).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0}) + '/'
                                         + Number($data.item.downvotesReviews).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})">
                </td>
                <td class="align-right colgroup-2 end">
                    <span data-bind="text: Number($data.item.uniqueTags).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})">
                </td>
                <!-- /ko -->

                <td class="align-right colgroup-5 start" data-bind="css: { end: !$root.loginStats.activitiesExpandMyLists() }">
                    <span data-bind="text: Number($data.item.totalListsInteractions).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})">
                </td>
                <!-- ko if: $root.loginStats.activitiesExpandMyLists() -->
                <td class="align-right colgroup-5">
                    <span data-bind="text: Number($data.item.listsStarted).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})">
                </td>
                <td class="align-right colgroup-5 end">
                    <span data-bind="text: Number($data.item.listsItemsAdded).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})">
                </td>
                <!-- /ko -->

                <td class="align-right colgroup-3 start" data-bind="css: { end: !$root.loginStats.activitiesExpandLikes() }">
                    <span data-bind="text: Number($data.item.totalLikes).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})">
                </td>
                <!-- ko if: $root.loginStats.activitiesExpandLikes() -->
                <td class="align-right colgroup-3">
                    <span data-bind="text: Number($data.item.articleLikes).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})">
                </td>
                <td class="align-right colgroup-3 end">
                    <span data-bind="text: Number($data.item.tagLikes).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})">
                </td>
                <!-- /ko -->

                <td class="align-right colgroup-2 start" data-bind="css: { end: !$root.loginStats.activitiesExpandPoll() }">
                    <span data-bind="text: Number($data.item.totalPoll || 0).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})">
                </td>
                <!-- ko if: $root.loginStats.activitiesExpandPoll() -->
                <td class="align-right colgroup-2">
                    <span data-bind="text: Number($data.item.pollLoaded || 0).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})">
                </td>
                <td class="align-right colgroup-2">
                    <span data-bind="text: Number($data.item.pollStarted || 0).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})">
                </td>
                <td class="align-right colgroup-2">
                    <span data-bind="text: Number($data.item.pollStartRatio || 0).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'">
                </td>
                <td class="align-right colgroup-2">
                    <span data-bind="text: Number($data.item.pollAnsweredQuestion || 0).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})">
                </td>
                <td class="align-right colgroup-2 end">
                    <span data-bind="text: Number($data.item.pollCompleted || 0).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})">
                </td>
                <!-- /ko -->
                
                <td class="align-right colgroup-5 start" data-bind="css: { end: !$root.loginStats.activitiesExpandSection4() }">
                    <span data-bind="text: Number($data.item.totalQuiz).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})">
                </td>
                <!-- ko if: $root.loginStats.activitiesExpandSection4() -->
                <td class="align-right colgroup-5">
                    <!-- quizLoaded tracking only began on 2026-03-19; display N/A for earlier dates -->
                    <span data-bind="text: ($data.item.rawDate && $data.item.rawDate < '2026-03-19') ? 'N/A' : Number($data.item.quizLoaded || 0).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})">
                </td>
                <td class="align-right colgroup-5">
                    <span data-bind="text: Number($data.item.quizStarted).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})">
                </td>
                <td class="align-right colgroup-5">
                    <!-- quizStartRatio depends on quizLoaded which was only tracked from 2026-03-19; display N/A for earlier dates -->
                    <span data-bind="text: ($data.item.rawDate && $data.item.rawDate < '2026-03-19') ? 'N/A' : Number($data.item.quizStartRatio || 0).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'">
                </td>
                <td class="align-right colgroup-5">
                    <span data-bind="text: Number($data.item.quizAnsweredQuestion).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})">
                </td>
                <td class="align-right colgroup-5">
                    <span data-bind="text: Number($data.item.quizCompleted).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})">
                </td>
                <td class="align-right colgroup-5">
                    <span data-bind="text: Number($data.item.quizRestarted).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})">
                </td>
                <td class="align-right colgroup-5 end">
                    <span data-bind="text: Number($data.item.quizJumpedToThread || 0).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})">
                </td>
                <!-- /ko -->

                <td class="align-right colgroup-4 start" data-bind="css: { end: !$root.loginStats.activitiesExpandCarMarketplace() }">
                    <span data-bind="text: Number($data.item.totalCarMarketplace || 0).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})">
                </td>
                <!-- ko if: $root.loginStats.activitiesExpandCarMarketplace() -->
                <td class="align-right colgroup-4">
                    <span data-bind="text: Number($data.item.carMarketplacePartnerDb || 0).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})">
                </td>
                <td class="align-right colgroup-4">
                    <span data-bind="text: Number($data.item.carMarketplacePartnerHomepage || 0).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})">
                </td>
                <td class="align-right colgroup-4">
                    <span data-bind="text: Number($data.item.carMarketplacePartnerMarketplace || 0).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})">
                </td>
                <td class="align-right colgroup-4">
                    <span data-bind="text: Number($data.item.carMarketplacePartnerPricetrend || 0).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})">
                </td>
                <td class="align-right colgroup-4">
                    <span data-bind="text: Number($data.item.carMarketplacePartnerCarousel || 0).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})">
                </td>
                <td class="align-right colgroup-4">
                    <span data-bind="text: Number($data.item.carMarketplaceMarketplaceInteractions || 0).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})">
                </td>
                <td class="align-right colgroup-4">
                    <span data-bind="text: Number($data.item.carMarketplacePriceTrendInteractions || 0).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})">
                </td>
                <td class="align-right colgroup-4 end">
                    <span data-bind="text: Number($data.item.carMarketplaceListingsCarouselInteractions || 0).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})">
                </td>
                <!-- /ko -->

                <td class="align-right colgroup-6 start end">
                    <span data-bind="text: Number($data.item.pageviews).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})">
                </td>
            </script>
        `;
    }

    protected buildViewModel(): any {
        
        let self = this;

        return {
            viewModes : ko.observableArray([]),
            viewModeSelectedText : ko.observable("Daily"),
            viewModeSelected : ko.observable("daily"),
            tabViewModeSelected : ko.observable("login"),
            viewModeLoading : ko.observable(false),
            selectedRows: ko.observableArray([]),
            totalIndexedProfiles: ko.observable("-"),
            totalProfiles: ko.observable("-"),
            totalActiveAccounts: ko.observable("-"),
            totalVerifiedAccounts: ko.observable("-"),
            totalPremiumUsers: ko.observable("-"),
            totalPremiumTrials: ko.observable("-"),
            monthlyPremiumUsers: ko.observable("-"),
            yearlyPremiumUsers: ko.observable("-"),
            deviceOptionSelectedText : ko.observable("All"),
            deviceOptions : ko.observableArray([]),
            deviceOptionSelected : ko.observable("all"),
            onViewModeChange : function(data){ self.onViewModeChange(data); },
            onTabViewModeChange : function(data){ self.onTabViewModeChange(data); },
            onDeviceOptionChange : function(data){ self.onDeviceOptionChange(data); },
            loginStatsDaily: ko.observableArray([]),
            loginStatsBrands: ko.observableArray([]),
            loginStatsTotals: ko.observable(""),
            dynamicEventNames: ko.observable([]),
            revenuePermissions : ko.observable(false),
            onClickRowClick: function(index, data){ self.onClickRowClick(index); return true; },
            loginExpandProviders: ko.observable(false),
            loginExpandStatic: ko.observable(false),
            loginExpandHeader: ko.observable(false),
            loginExpandThread: ko.observable(false),
            loginExpandLike: ko.observable(false),
            loginExpandFollow: ko.observable(false),
            loginExpandQuiz: ko.observable(false),
            loginExpandPremium: ko.observable(false),
            loginExpandArticleContent: ko.observable(false),
            loginExpandTagListRating: ko.observable(false),
            loginExpandNewsletterWidgets: ko.observable(false),
            loginExpandProvidersButtonClass: ko.observable("i-expand"),
            loginExpandStaticButtonClass: ko.observable("i-expand"),
            loginExpandHeaderButtonClass: ko.observable("i-expand"),
            loginExpandThreadButtonClass: ko.observable("i-expand"),
            loginExpandLikeButtonClass: ko.observable("i-expand"),
            loginExpandFollowButtonClass: ko.observable("i-expand"),
            loginExpandQuizButtonClass: ko.observable("i-expand"),
            loginExpandPremiumButtonClass: ko.observable("i-expand"),
            loginExpandArticleContentButtonClass: ko.observable("i-expand"),
            loginExpandTagListRatingButtonClass: ko.observable("i-expand"),
            loginExpandNewsletterWidgetsButtonClass: ko.observable("i-expand"),
            onLoginExpandProviders: function(){ self.toggleLoginSection('loginExpandProviders'); },
            onLoginExpandStatic: function(){ self.toggleLoginSection('loginExpandStatic'); },
            onLoginExpandHeader: function(){ self.toggleLoginSection('loginExpandHeader'); },
            onLoginExpandThread: function(){ self.toggleLoginSection('loginExpandThread'); },
            onLoginExpandLike: function(){ self.toggleLoginSection('loginExpandLike'); },
            onLoginExpandFollow: function(){ self.toggleLoginSection('loginExpandFollow'); },
            onLoginExpandQuiz: function(){ self.toggleLoginSection('loginExpandQuiz'); },
            onLoginExpandPremium: function(){ self.toggleLoginSection('loginExpandPremium'); },
            onLoginExpandArticleContent: function(){ self.toggleLoginSection('loginExpandArticleContent'); },
            onLoginExpandTagListRating: function(){ self.toggleLoginSection('loginExpandTagListRating'); },
            onLoginExpandNewsletterWidgets: function(){ self.toggleLoginSection('loginExpandNewsletterWidgets'); },
            activitiesExpandThreads: ko.observable(false),
            activitiesExpandFollows: ko.observable(false),
            activitiesExpandRatings: ko.observable(false),
            activitiesExpandMyLists: ko.observable(false),
            activitiesExpandLikes: ko.observable(false),
            activitiesExpandPoll: ko.observable(false),
            activitiesExpandSection4: ko.observable(false),
            activitiesExpandCarMarketplace: ko.observable(false),
            activitiesExpandThreadsButtonClass: ko.observable("i-expand"),
            activitiesExpandFollowsButtonClass: ko.observable("i-expand"),
            activitiesExpandRatingsButtonClass: ko.observable("i-expand"),
            activitiesExpandMyListsButtonClass: ko.observable("i-expand"),
            activitiesExpandLikesButtonClass: ko.observable("i-expand"),
            activitiesExpandPollButtonClass: ko.observable("i-expand"),
            activitiesExpandSection4ButtonClass: ko.observable("i-expand"),
            activitiesExpandCarMarketplaceButtonClass: ko.observable("i-expand"),
            onActivitiesExpandThreads: function(){ self.onActivitiesExpandThreads(); },
            onActivitiesExpandFollows: function(){ self.onActivitiesExpandFollows(); },
            onActivitiesExpandRatings: function(){ self.onActivitiesExpandRatings(); },
            onActivitiesExpandMyLists: function(){ self.onActivitiesExpandMyLists(); },
            onActivitiesExpandLikes: function(){ self.onActivitiesExpandLikes(); },
            onActivitiesExpandPoll: function(){ self.onActivitiesExpandPoll(); },
            onActivitiesExpandSection4: function(){ self.onActivitiesExpandSection4(); },
            onActivitiesExpandCarMarketplace: function(){ self.onActivitiesExpandCarMarketplace(); }
        }
    }

    public getViewModelForRequest() {
        return {
            viewMode: this.getTemplateViewModel().viewModeSelected(),
            tabViewMode: this.getTemplateViewModel().tabViewModeSelected(),
            countries: this.getTemplateViewModel().countriesFilter.selectedItems(),
            deviceOption: this.getTemplateViewModel().deviceOptionSelected(),
            startDate: this.getTemplateViewModel().datesFilter.startDate(),
            endDate: this.getTemplateViewModel().datesFilter.endDate(),
            brands: this.getTemplateViewModel().brandsFilter.selectedItems(),
            permalink: this.getTemplateViewModel().permalinkFilter.filterKeyword(),
        };

    }

    public build(classesToAdd: Array<string> = []): HTMLElement {

        let container = super.build(classesToAdd);

        return container;
    }


    public buildDatePickerCalendar(){
        this.datesFilter.buildCalendar();
    }


    public setViewModesItems() {
        this.getTemplateViewModel().viewModes(this.viewModes);
    }

    public setDeviceOptionsFilterItems(){
        this.getTemplateViewModel().deviceOptions(this.deviceOptions);
    }

    public setTotalActiveAccounts($totalActiveAccounts){

        this.getTemplateViewModel().totalActiveAccounts();
        this.getTemplateViewModel().totalActiveAccounts($totalActiveAccounts);
    }

    public setTotalProfiles($totalProfiles){

        this.getTemplateViewModel().totalProfiles();
        this.getTemplateViewModel().totalProfiles($totalProfiles);
    }

    public setTotalIndexedProfiles($totalIndexedProfiles){

        this.getTemplateViewModel().totalIndexedProfiles();
        this.getTemplateViewModel().totalIndexedProfiles($totalIndexedProfiles);
    }


    public setTotalVerifiedAccounts($totalVerifiedAccounts){

        this.getTemplateViewModel().totalVerifiedAccounts();
        this.getTemplateViewModel().totalVerifiedAccounts($totalVerifiedAccounts);
    }

    public setTotalPremiumUsers($totalPremiumUsers){

        this.getTemplateViewModel().totalPremiumUsers();
        this.getTemplateViewModel().totalPremiumUsers($totalPremiumUsers);
    }

    public setTotalPremiumTrials($totalPremiumTrials){

        this.getTemplateViewModel().totalPremiumTrials();
        this.getTemplateViewModel().totalPremiumTrials($totalPremiumTrials);
    }

    public setMonthlyPremiumUsers($monthlyPremiumUsers){

        this.getTemplateViewModel().monthlyPremiumUsers();
        this.getTemplateViewModel().monthlyPremiumUsers($monthlyPremiumUsers);
    }

    public setYearlyPremiumUsers($yearlyPremiumUsers){

        this.getTemplateViewModel().yearlyPremiumUsers();
        this.getTemplateViewModel().yearlyPremiumUsers($yearlyPremiumUsers);
    }

    public setBrandFilterItems(departments){

        let groups = [];
        for ( let department of departments){
            let group = {"name" : department.name, "logo" : department.logo, "items" : department.brands};
            groups.push(group);
        }
        this.brandsFilter.setMultiSectionItems(groups);
        this.brandsFilter.setLabel('Brands');
    }


    public setCountriesFilterItems(groupedCountries){

        this.countriesFilter.setMultiSectionItems(groupedCountries);
        this.countriesFilter.setLabel('Countries');
    }

    public setRevenuePermissions(revenuePermissions){

        this.getTemplateViewModel().revenuePermissions(revenuePermissions);
    }

    public setLoginStatsDaily(loginStatsDaily) {

        this.getTemplateViewModel().loginStatsDaily(loginStatsDaily);
    }

    public setLoginStatsBrands(loginStatsBrands) {

        this.getTemplateViewModel().loginStatsBrands(loginStatsBrands);
    }


    public setDynamicEventNames(dynamicEventNames) {

        this.getTemplateViewModel().dynamicEventNames(dynamicEventNames);
    }

    public setLoginStatsTotals(loginStatsTotals) {

        this.getTemplateViewModel().loginStatsTotals(loginStatsTotals);
    }

    private onViewModeChange(selected) {

        this.getTemplateViewModel().viewModeSelectedText(selected.name);    
        this.caller.getListData();
    }

    private onTabViewModeChange(selected) {

        this.getTemplateViewModel().tabViewModeSelected(selected);
        this.caller.getListData();
    }

    private onDeviceOptionChange(selectedDeviceOption){

        this.getTemplateViewModel().deviceOptionSelectedText(selectedDeviceOption.name);

        this.caller.getListData();
    }

    public setViewModelFromRequest(params : Array<any>): void{

        this.presetFilter.setMultiSelectorPresetFilters(this.brandsFilter, params['brands']);
        this.presetFilter.setMultiSelectorPresetFilters(this.countriesFilter, params['countries']);

        this.presetFilter.setDates(this.datesFilter, params['dateFilterType'], params['startDate'], params['endDate'], params['startDateRange'], params['endDateRange']);

        if(typeof params['viewMode'] !== 'undefined'){

            this.getTemplateViewModel().viewModeSelected(params['viewMode']);
            this.getTemplateViewModel().viewModeSelectedText(this.presetFilter.getFilterTextFromId(this.viewModes, params['viewMode']));
        }

        if(typeof params['tabViewMode'] !== 'undefined'){

            this.getTemplateViewModel().tabViewModeSelected(params['tabViewMode']);
        }

        if(typeof params['deviceOption'] !== 'undefined'){

            this.getTemplateViewModel().deviceOptionSelected(params['deviceOption']);
            this.getTemplateViewModel().deviceOptionSelectedText(this.presetFilter.getFilterTextFromId(this.deviceOptions, params['deviceOption']));
        }

        if(typeof params['permalink'] !== 'undefined'){

            this.permalinkFilter.getTemplateViewModel().filterKeyword(params['permalink']);
        }
    }

    private onClickRowClick(index){

        let selectedRows = this.getTemplateViewModel().selectedRows();
        let check = selectedRows.indexOf(index);

        if (check !== -1) {

            selectedRows.splice(check, 1);
        }else {

            selectedRows.push(index);
        }

        this.getTemplateViewModel().selectedRows(selectedRows);
    }

    private toggleLoginSection(observableName: string) {
        const vm = this.getTemplateViewModel();
        const expanded = !vm[observableName]();
        vm[observableName](expanded);
        vm[`${observableName}ButtonClass`](expanded ? "i-simplify" : "i-expand");
    }

    private onActivitiesExpandThreads(){
        const vm = this.getTemplateViewModel();
        const expanded = !vm.activitiesExpandThreads();
        vm.activitiesExpandThreads(expanded);
        vm.activitiesExpandThreadsButtonClass(expanded ? "i-simplify" : "i-expand");
    }

    private onActivitiesExpandFollows(){
        const vm = this.getTemplateViewModel();
        const expanded = !vm.activitiesExpandFollows();
        vm.activitiesExpandFollows(expanded);
        vm.activitiesExpandFollowsButtonClass(expanded ? "i-simplify" : "i-expand");
    }

    private onActivitiesExpandRatings(){
        const vm = this.getTemplateViewModel();
        const expanded = !vm.activitiesExpandRatings();
        vm.activitiesExpandRatings(expanded);
        vm.activitiesExpandRatingsButtonClass(expanded ? "i-simplify" : "i-expand");
    }

    private onActivitiesExpandMyLists(){
        const vm = this.getTemplateViewModel();
        const expanded = !vm.activitiesExpandMyLists();
        vm.activitiesExpandMyLists(expanded);
        vm.activitiesExpandMyListsButtonClass(expanded ? "i-simplify" : "i-expand");
    }

    private onActivitiesExpandLikes(){
        const vm = this.getTemplateViewModel();
        const expanded = !vm.activitiesExpandLikes();
        vm.activitiesExpandLikes(expanded);
        vm.activitiesExpandLikesButtonClass(expanded ? "i-simplify" : "i-expand");
    }

    private onActivitiesExpandPoll(){
        const vm = this.getTemplateViewModel();
        const expanded = !vm.activitiesExpandPoll();
        vm.activitiesExpandPoll(expanded);
        vm.activitiesExpandPollButtonClass(expanded ? "i-simplify" : "i-expand");
    }

    private onActivitiesExpandSection4(){
        const vm = this.getTemplateViewModel();
        const expanded = !vm.activitiesExpandSection4();
        vm.activitiesExpandSection4(expanded);
        vm.activitiesExpandSection4ButtonClass(expanded ? "i-simplify" : "i-expand");
    }

    private onActivitiesExpandCarMarketplace(){
        const vm = this.getTemplateViewModel();
        const expanded = !vm.activitiesExpandCarMarketplace();
        vm.activitiesExpandCarMarketplace(expanded);
        vm.activitiesExpandCarMarketplaceButtonClass(expanded ? "i-simplify" : "i-expand");
    }

    public resetSelectedRows(){

        this.getTemplateViewModel().selectedRows([]);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/loginStats_template.ts